import { type ReactNode } from "react"

import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui"
import { useLayoutStore } from "@/modules/helpers/hooks/shared"

interface BottomSheetModalProps {
  children: ReactNode
  title?: string
  description?: string
  isVisible: boolean
  setIsVisible?: (status: boolean) => void
}

const BottomSheetModal: React.FC<BottomSheetModalProps> = ({
  children,
  isVisible,
  title,
  description,
  setIsVisible
}) => {
  const { insetBottom } = useLayoutStore()

  return (
    <Sheet
      open={isVisible}
      onOpenChange={(open) => {
        setIsVisible?.(open)
      }}
    >
      <SheetContent
        side={"bottom"}
        className="rounded-t-3xl bg-white"
        style={{ paddingBottom: insetBottom }}
      >
        <SheetHeader>
          <SheetTitle className="text-left lg:text-md font-semibold">{title}</SheetTitle>
          <SheetDescription className="text-left italic">{description}</SheetDescription>
        </SheetHeader>
        {children}
      </SheetContent>
    </Sheet>
  )
}

export { BottomSheetModal }
